<template>
  <div>
    <v-header></v-header>
    <div class="a-main">
        <router-view></router-view>
    </div>
    
    <v-footer></v-footer>
  </div>
</template>

<script>
    import Header from '@/components/common/Header'
    import Footer from '@/components/common/Footer'
    export default {
        name: '',
        data () {
            return {}
        },
        components:{
            'v-header':Header,
            'v-footer':Footer
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @media screen and (max-width: 768px) {
        .a-main{
            padding-top:50px;
        }
    }
    
</style>



// WEBPACK FOOTER //
// HomePanel.vue?dc1fff1a